import ActionType from '../action';

export function setSessionData(payload) {
  return ({ type: ActionType.SET_SESSION_DATA, payload});
}

export default {
  setSessionData
}
